import * as R from 'ramda';
import { CustomError } from '../../common/errors';
import { Step, StepValue, ValidationStep } from '../../services/validation';

export default class StepError extends CustomError {
  public invalidStep: boolean;

  public stepName: ValidationStep;

  public stepValue: StepValue;

  public errorCodes: string[];

  constructor(
    message: string,
    step: ValidationStep,
    invalidStep: boolean,
    stepValue: StepValue = {},
    errorCodes: string[] = [],
    nestedError?: Error,
  ) {
    super(message, nestedError);
    this.stepName = step;
    this.errorCodes = errorCodes;
    this.invalidStep = invalidStep;
    this.stepValue = stepValue;
  }

  static fromError(step: ValidationStep, error: CustomError): StepError {
    return new StepError(`Unexpected error processing step: ${step}`, step, false, {}, [], error);
  }

  static fromFailedStep(step: Step): StepError {
    return new StepError(
      `Step failed with invalid status: ${step.name}`,
      step.name,
      true,
      step.value,
      step.errorCodes || [],
    );
  }
}

export const isInvalidStepError = (error: CustomError): boolean => {
  if (R.is(StepError, error)) {
    const stepError = error as StepError;
    return stepError.invalidStep;
  }

  return false;
};
